import { render, staticRenderFns } from "./ModalZoomImagem.vue?vue&type=template&id=d27c867c&"
import script from "./ModalZoomImagem.vue?vue&type=script&lang=js&"
export * from "./ModalZoomImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports